"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPlaceholderView = exports.StyledPlaceholderText = exports.StyledIconContainer = void 0;
var _ykbStyledComponents = require("../../ykb-styled-components");
var _StyledIcon = _interopRequireDefault(require("../../Icon/StyledIcon"));
var StyledIconContainer = exports.StyledIconContainer = _ykbStyledComponents.styled.div.withConfig({
  componentId: "ykb-ui__sc-1eknai7-0"
})([""]);
var StyledPlaceholderText = exports.StyledPlaceholderText = _ykbStyledComponents.styled.div.withConfig({
  componentId: "ykb-ui__sc-1eknai7-1"
})([""]);
var StyledPlaceholderView = exports.StyledPlaceholderView = _ykbStyledComponents.styled.div.withConfig({
  componentId: "ykb-ui__sc-1eknai7-2"
})(["display:flex;justify-content:center;align-items:center;flex-direction:column;", " ", "{height:80px;width:80px;display:flex;justify-content:center;align-items:center;border-radius:40px;border:none;margin:20px;background-color:", ";}", "{margin:20px;cursor:pointer;}", "{", ";color:", ";margin-bottom:20px;}"], function (props) {
  return props.$minHeight && (0, _ykbStyledComponents.css)(["height:calc(", "px - 40px) !important;"], props.$minHeight);
}, StyledIconContainer, function (props) {
  return props.theme.color.default1;
}, _StyledIcon.default, StyledPlaceholderText, function (props) {
  return props.theme.mixins.resetComponent(_ykbStyledComponents.css);
}, function (props) {
  return props.theme.color.neutral11;
});